import React, { useEffect, useState } from "react";
import clsx from "clsx";

import styles from "./PriceButton.module.scss";
import { ClickType } from "../../../state/settings/settingsState";
import { decimalToPriceObjectConverterBySymbol } from "../../../lib/util";
import { PriceHighlighted } from "./PriceHighlighted";
import { removeCommasAndAddMultiplierShortcuts } from "../../../lib/formatUtil";

type PriceButtonProps = {
  clickType: string;
  isTradingEnabled?: boolean;
  onQuickTrade: () => void;
  priceObj: any;
  size?: string; //sm, lg
  testid?: string;
  isCrypto: boolean;
  quantity?: any;
  book?: any;
};

export const PriceButton = ({
  isTradingEnabled,
  priceObj,
  clickType,
  onQuickTrade,
  size,
  testid,
  isCrypto,
  quantity,
  book,
}: PriceButtonProps) => {
  size = size || "sm";

  const isDepthTradingEnabled = isTradingEnabled === undefined ? true : isTradingEnabled;

  const optionalAttribute = testid ? { "data-testid": testid } : {};

  const priceButton = !isDepthTradingEnabled ? (
    <div
      className={clsx(
        styles.priceCell,
        size === "lg" ? `priceCellLg ${styles.priceCellLg}` : `priceCellSm ${styles.priceCellSm}`,
        styles.priceTradeDisabled
      )}
    >
      <PriceHighlighted finalPriceObj={priceObj} optionalAttribute={optionalAttribute} />
    </div>
  ) : (
    <div
      className={clsx(
        styles.priceCell,
        (!priceObj || quantity === null || quantity === "" || quantity === 0) && styles.disabled,
        size === "lg" ? `priceCellLg ${styles.priceCellLg}` : `priceCellSm ${styles.priceCellSm}`
      )}
      onDoubleClick={() => {
        if (clickType === ClickType.Double) {
          if (priceObj && quantity !== null && quantity !== "" && quantity !== 0) {
            onQuickTrade();
          } else {
            return null;
          }
        }
      }}
      onClick={() => {
        if (clickType === ClickType.Single) {
          if (priceObj && quantity !== null && quantity !== "" && quantity !== 0) {
            onQuickTrade();
          } else {
            return null;
          }
        }
      }}
    >
      <PriceHighlighted finalPriceObj={priceObj} optionalAttribute={optionalAttribute} />
    </div>
  );

  return priceButton;
};
